
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
import Paginator from 'primevue/paginator';
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import ProgressSpinner from 'primevue/progressspinner';
import { onMounted, ref, watch } from 'vue';
import { formatThaiDateTime } from '../utils/date';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { affiliate } from '../apis/affiliate';
import { useToast } from 'primevue/usetoast';
import { formatCurrency } from '../utils/currency';

export default {
	name: 'AffiliateDownline',
	methods: { formatCurrency },
	components: {
		DataTable,
		Column,
		ColumnGroup,
		Row,
		Paginator,
		IftaLabel,
		Tag,
		Card,
		Button,
		ProgressSpinner,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const cardLoading = ref(false);
		const tableLoading = ref(false);
		const btnLoading = ref(false);

		const selectUsername = ref(profile.value?.username || '');
		const usernameStack = ref<string[]>([]); // stack สำหรับย้อนกลับ

		const first = ref(0); // เริ่ม index
		const rows = ref(10); // จำนวนต่อหน้า
		const totalRecords = ref(0); // จำนวนทั้งหมด

		const downlines = ref([]);

		const handleAffiliateChild = async (username: string) => {
			tableLoading.value = true;

			const page = Math.floor(first.value / rows.value) + 1;
			const payload = {
				username: username,
				page: page,
				size: rows.value,
			};

			try {
				const resp = await affiliate.getAffiliateChildById(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				downlines.value = resp.result || [];
				totalRecords.value = resp.result?.total || resp.result?.length || 0;
			} catch (error) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาดบางอย่าง',
					detail: String(error),
					life: 3000,
				});
			} finally {
				tableLoading.value = false;
			}
		};

		const clickBtnToParent = async () => {
			if (usernameStack.value.length === 0) return;

			// ย้อนกลับ 1 ระดับ
			const parentUsername = usernameStack.value.pop();
			if (parentUsername) {
				selectUsername.value = parentUsername;
				await handleAffiliateChild(parentUsername);
			}
		};

		const clickBtnWatchChild = async (username: string) => {
			// บันทึก username ปัจจุบันไว้ก่อนจะเปลี่ยน
			usernameStack.value.push(selectUsername.value);

			selectUsername.value = username;
			await handleAffiliateChild(username);
		};

		const onPageChange = (event: any) => {
			first.value = event.first;
			rows.value = event.rows;
		};

		onMounted(() => {
			handleAffiliateChild(selectUsername.value);
		});

		watch([selectUsername, first, rows], ([username]) => {
			if (username) {
				handleAffiliateChild(username);
			}
		});

		return {
			profile,
			tableLoading,
			selectUsername,
			downlines,
			first,
			rows,
			totalRecords,
			onPageChange,
			formatThaiDateTime,
			clickBtnWatchChild,
			clickBtnToParent,
			usernameStack,
		};
	},
};
